export function Empty({ text }) {
  return <div className="col-span-full text-center py-16 text-slate-400 border border-dashed border-slate-300 rounded-md">{text}</div>;
}
